import PropTypes from 'prop-types';
import { useContext } from 'react';
import {
    pageFrameWithChildrenCSS,
    pageFrameWithOverlayCSS,
} from './styles/RevStatsPageContent.styles';
import OverlayContext, { Overlays } from '../../common/containers/OverlayContext';
import RevStatsSearchInputMobile from './Navigation/RevStatsSearchInputMobile';
import UserMenuMobile from './Navigation/UserDropdownMenu/UserMenuMobile';

export default function RevStatsPageContent({ children }) {
    const { overlay } = useContext(OverlayContext);
    // Use "display: none" around the <Outlet /> in order to preserve state in items such as Overlays
    // Do not use if/else statements as this will tell React to destroy the underlying tree
    return (
        <>
            {overlay === Overlays.SEARCH ? <RevStatsSearchInputMobile /> : null}
            {overlay === Overlays.USER_DROPDOWN ? <UserMenuMobile /> : null}
            <div css={overlay ? pageFrameWithOverlayCSS : pageFrameWithChildrenCSS}>{children}</div>
        </>
    );
}
RevStatsPageContent.propTypes = {
    children: PropTypes.node,
};
